"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeafWithChainNodeSchema = exports.ChainNodeSchema = exports.ChainNodeTypeEnum = exports.PercentageSchema = exports.PositiveIntegerSchema = exports.NonNegativeIntegerSchema = exports.PositiveNumberSchema = exports.NonNegativeNumberSchema = exports.NumberSchema = exports.IntegerSchema = exports.ISODateTimeSchema = exports.ISODateSchema = exports.UUIDSchema = void 0;
const zod_1 = require("zod");
const localized_schema_1 = require("./localized.schema");
exports.UUIDSchema = zod_1.z.uuid();
exports.ISODateSchema = zod_1.z.string().date();
exports.ISODateTimeSchema = zod_1.z.iso.datetime({ offset: true });
exports.IntegerSchema = zod_1.z.number().int();
exports.NumberSchema = zod_1.z.number();
exports.NonNegativeNumberSchema = zod_1.z.number().min(0);
exports.PositiveNumberSchema = zod_1.z.number().min(1);
exports.NonNegativeIntegerSchema = zod_1.z.number().int().min(0);
exports.PositiveIntegerSchema = zod_1.z.number().int().min(1);
exports.PercentageSchema = zod_1.z.number().min(0).max(100);
exports.ChainNodeTypeEnum = zod_1.z.enum(['INDUSTRY', 'OCCUPATION']);
exports.ChainNodeSchema = zod_1.z.object({
    id: exports.UUIDSchema,
    localized: localized_schema_1.LocalizedFieldSchema,
    type: exports.ChainNodeTypeEnum,
});
exports.LeafWithChainNodeSchema = zod_1.z.object({
    id: exports.UUIDSchema,
    chain: exports.ChainNodeSchema.omit({ type: true }).array(),
    localized: localized_schema_1.LocalizedFieldSchema,
    type: exports.ChainNodeTypeEnum,
});
